export default __webpack_public_path__ + "static/media/img_11.d381a066.jpg";